import { useState } from 'react';
import { Card } from 'react-bootstrap';
import { Button, ButtonGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import { useNavigate } from 'react-router-dom';
import RightHeaderPage from './rightHeader';

const IncludedExcludedOfficerPage = () => {
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([
    {
      id: 1,
      state: 'CA',
      name: 'John Doe',
      annualPay: '$50,000',
      ownership: 'Owner',
      includeExclude: 'Include',
    },
    {
      id: 2,
      state: 'NY',
      name: 'Jane Smith',
      annualPay: '$60,000',
      ownership: 'Employee',
      includeExclude: 'Exclude',
    },
  ]);

  const handleDelete = (id) => {
    setRowData(rowData.filter((row) => row.id !== id));
  };

  const handleEdit = (data) => {
    alert(`Edit: ${data.name}`);
  };

  const columnDefs = [
    { headerName: 'State', field: 'state', flex: 1 },
    { headerName: 'Name', field: 'name', flex: 1 },
    { headerName: 'Annual Pay', field: 'annualPay', flex: 1 },
    { headerName: 'Ownership', field: 'ownership', flex: 1 },
    { headerName: 'Include/Exclude', field: 'includeExclude', flex: 1 },
    {
      headerName: 'Action',
      field: 'action',
      flex: 1,
      cellRenderer: (params) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            cursor: 'pointer',
            marginTop: '.8rem',
          }}
        >
          {/* Edit Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
            <path
              fillRule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>

          {/* Delete Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path
              fillRule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            />
          </svg>
        </div>
      ),
    },
  ];

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className=" container-fluid ">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/LossDetailPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/UnderwritingInformationPage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Included Excluded Officer
                              <div className=" quote_buttongroup  ">
                                <Button
                                  variant="outline-next"
                                  size="sm"
                                  className="button-icon"
                                  style={{
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 5v14M5 12h14"
                                      className="add_Svg"
                                      stroke="#7C67AD"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                  Add New
                                </Button>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <div
                                className="ag-theme-balham quote-grid-style"
                                style={{
                                  width: '100%',
                                  border: '1px solid #ddd',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                }}
                              >
                                <AgGridReact
                                  columnDefs={columnDefs}
                                  rowData={rowData}
                                  animateRows={true}
                                  rowSelection="multiple"
                                  pagination={true}
                                  paginationPageSize={10}
                                  domLayout="autoHeight"
                                />
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IncludedExcludedOfficerPage;
